<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">With best wishes:</p>
<p style="text-align: center;">to Whylda for all her understanding – and to my siblings, cousins, second cousins and all<br/>
who came before them…</p>
<p style="text-align: center;">and to my father and mother – John and<br/>
Natalie Ruth Brown.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?71652664